import { PropClinicalProgramsFilterFilterNameEnum } from '@calm/evexia-analytics';

export function categoryNameToAnalyticsFilterName(
    name?: string
): PropClinicalProgramsFilterFilterNameEnum | undefined {
    if (!name) return undefined;
    switch (name) {
        case 'All':
            return PropClinicalProgramsFilterFilterNameEnum.All;
        case "Women's Health":
            return PropClinicalProgramsFilterFilterNameEnum.WomensHealth;
        case 'Healthy Weight':
            return PropClinicalProgramsFilterFilterNameEnum.HealthyWeight;
        case 'Family (Parents, siblings)':
            return PropClinicalProgramsFilterFilterNameEnum.FamilyParentsSiblings;
        case 'Anxiety (Worry, Stress)':
            return PropClinicalProgramsFilterFilterNameEnum.AnxietyWorryStress;
        case 'Reproductive Health':
            return PropClinicalProgramsFilterFilterNameEnum.ReproductiveHealth;
        case "Men's Health":
            return PropClinicalProgramsFilterFilterNameEnum.MensHealth;
        case 'Work':
            return PropClinicalProgramsFilterFilterNameEnum.Work;
        case 'Military':
            return PropClinicalProgramsFilterFilterNameEnum.Military;
        case 'Physical Health':
            return PropClinicalProgramsFilterFilterNameEnum.PhysicalHealth;
        case 'LGBTQ+':
            return PropClinicalProgramsFilterFilterNameEnum.Lgbtq;
        case 'Therapy':
            return PropClinicalProgramsFilterFilterNameEnum.Therapy;
        case 'College':
            return PropClinicalProgramsFilterFilterNameEnum.College;
        case 'Teenagers':
            return PropClinicalProgramsFilterFilterNameEnum.Teenagers;
        default:
            return undefined;
    }
}
